import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { EmployeeDataRepository } from "../domain/EmployeeDataRepository";
import { EmployeeDataResume } from "../domain/EmployeeDataResume";
import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { EmployeeSumReconciliationByYearMonth } from "../domain/EmployeeSumReconciliationByYearMonth";
import { EmployeeSumReconciliation } from "../domain/EmployeeSumReconciliation";

export function createApiEmployeeDataRepository(): EmployeeDataRepository {
  return new APIEmployeeDataRepository();
}

export class APIEmployeeDataRepository
  extends APIRepository
  implements EmployeeDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }


  getEmployeesWithResumeByCompany(companyId: string, year: number): Promise<EmployeeDataResume[]> {
    console.log("getEmployeesWithResumeByCompany companyId: " + companyId);
    console.log("getEmployeesWithResumeByCompany year: " + year);
    return this.doGet<EmployeeDataResume[]>("/api/employeesdata/resume/company/" + companyId.toString() + "/year/" + year);
  }


  listResumeReconciliationEmployeesYearMonth(companyUid: string): Promise<EmployeeSumReconciliationByYearMonth[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<EmployeeSumReconciliationByYearMonth[]>("/api/expensesdata/resume/company/" + companyUid.toString() + "/resumeEmployeesReconciliationByYearMonth" );
    }
  }

  listResumeReconciliationEmployees(companyUid: string): Promise<EmployeeSumReconciliation>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<EmployeeSumReconciliation>("/api/expensesdata/resume/company/" + companyUid.toString() + "/resumeEmployeesReconciliation" );
    }
  }

  listEmployeesResumeByCompanyYear(companyUid: string, year:number): Promise<EmployeeDataResume[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<EmployeeDataResume[]>("/api/employeesdata/resume/company/" + companyUid.toString() + "/year/" + year);
      
    }
  }
  
  listEmployeesResumeByCompanyYearMonth(companyUid: string, year:number, month:number): Promise<EmployeeDataResume[]>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<EmployeeDataResume[]>("/api/employeesdata/resume/company/" + companyUid.toString() + "/year/" + year.toString() + "/month/" + month.toString());
    }
  }



}
